import React from 'react';
import Header from '../../shared/header';
import { userStore } from '../../store/UserStore';
import { useHistory } from 'react-router-dom';
import Toast from '../../shared/common/toast';

interface PropTypes {
  children: any;
  isLinkShow?: boolean;
}

const Layout: React.FC<PropTypes> = ({ children, isLinkShow = true }) => {
  const history = useHistory();

  const [selectedAccount, customer] = userStore((state: any) => [
    state.selectedAccount,
    state.customer,
  ]);

  return (
    <>
      <Toast />
      {/* <Header /> */}
      {(customer?.active === 'DISABLED' ||
        // Object.keys(selectedAccount).length === 0 ||
        selectedAccount?.active === 'DISABLED') &&
        isLinkShow && (
          <div className='text-center bg-danger text-white p-1'>
            <a
              href='#'
              onClick={() => history.push('/profile')}
              style={{ color: '#fff', textDecoration: 'none' }}
            >
              {' '}
              <img src='information-button.png' className='p-1' alt='' /> Please
              complete your profile for the activation your account.
            </a>
          </div>
        )}

      <Header isLinkShow={isLinkShow} />

      <main className='inner-wrapper container'>
        <div>{children}</div>
      </main>
    </>
  );
};

export default Layout;
